import React, { useEffect, useState } from 'react'
import { Card, CardBody, Col, Label, Modal, ModalBody, ModalHeader, Row, Table } from 'reactstrap'
import useApi from 'common/ApiMiddlewere'
import toast from 'react-hot-toast'
import { GetObjByHandWorkCostingStatus } from '_mock/Static_data'
import { dateFormat } from 'pages/Common'

const HandWorkDetailModel = ({ modal, toggle, handWorkId }) => {
    const { getApi } = useApi()
    const [handworkData, setHandWorkData] = useState({})
    const [otherCosts, setOtherCosts] = useState([])
    const [Workers, setWorkers] = useState([])

    useEffect(() => {
        if (handWorkId > 0) {
            getApi(`HandWorkCosting/details?id=${handWorkId}`).then(({ data, status }) => {
                if (status === 200) {
                    setHandWorkData(data?.HandWorkDetail)
                    setWorkers(data?.Workers)
                    setOtherCosts(data?.OtherCosts)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
            })
        }
    }, [modal])

    return (
        <Modal isOpen={modal} toggle={toggle} centered={true} size="xl" style={{ width: "900px" }}>
            <div className="modal-content">
                <ModalHeader className="text-centre" toggle={toggle} tag="h5">
                    <span style={{ fontWeight: "600", fontSize: "20px", marginLeft: "8px" }}> Details </span>
                </ModalHeader>
                <ModalBody>
                    <React.Fragment>
                        <Row>
                            <Col lg="12">
                                <Card>
                                    <CardBody className="p-1">
                                        <Row>
                                            <Col sm="5" className="text-sm-start">
                                                <address style={{ marginBottom: "4px" }}>
                                                    <span style={{ fontSize: "15px", fontWeight: "600" }}>
                                                        Designer: </span>
                                                    <span style={{ fontSize: "14px" }}>
                                                        {handworkData?.DesignerByName}
                                                    </span>
                                                </address>
                                            </Col>
                                            <Col sm="7" className="text-end"><address className="mb-0">
                                                <span style={{ fontSize: "16px", fontWeight: "600" }}>
                                                    Date: </span>
                                                <span style={{ fontSize: "14px" }}>
                                                    {dateFormat(handworkData?.CreatedOn?.split("T")[0], "dd-MM-yyyy")}</span>
                                                {/* <br /> */}
                                                <br />
                                            </address>
                                                <span>
                                                    <span style={{ fontSize: "16px", fontWeight: "600" }}>
                                                        Status: </span>
                                                    <span style={{ fontSize: "14px", fontWeight: "500" }}>{GetObjByHandWorkCostingStatus(handworkData?.Status)[0]?.Key}</span>
                                                </span>
                                            </Col>
                                        </Row>
                                        <Row className="py-1 mt-3">
                                            <Col sm={4}><div >
                                                <h3 className="font-size-16" style={{ fontWeight: "600" }}>Workers</h3>
                                            </div></Col>
                                        </Row>
                                        <div className="table-responsive">
                                            <Table className="table-nowrap" bordered>
                                                <thead>
                                                    <tr>
                                                        <th className="custom-header-invoice" style={{ width: "20px" }}>No.</th>
                                                        <th className="custom-header-invoice" style={{ width: "100%" }}>Name</th>
                                                        <th className="custom-header-invoice" style={{ width: "40px" }}>Hours</th>
                                                        <th className="custom-header-invoice" style={{ width: "40px" }} >Cost</th>
                                                        <th className="custom-header-invoice" style={{ width: "40px" }}>Total Cost</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Workers.length == 0 ? <tr> <td style={{ textAlign: "center", fontSize: "15px" }} colSpan={5}>No Worker</td></tr> : Workers?.map((item, index) => (
                                                        <tr key={item.Id || index}>
                                                            <td className='custom-header1'>{index + 1}</td>
                                                            <td className='custom-header1'>{item?.WorkerName}</td>
                                                            <td className='custom-header1'>
                                                                {item?.TotalHours}
                                                            </td>
                                                            <td className='custom-header1 text-end'>
                                                                <span>
                                                                    <i className="mdi 
                                                    mdi-currency-inr"></i>
                                                                    {new Intl.NumberFormat('en-IN', {
                                                                        currency: 'INR',
                                                                        minimumFractionDigits: 2,
                                                                    }).format(Math.round((item?.WorkerCost)) || 0)}</span>
                                                            </td>
                                                            <td className='custom-header1 text-end'>
                                                                <span>
                                                                    <i className="mdi mdi-currency-inr"></i>
                                                                    {(() => {
                                                                        // safely handle missing values
                                                                        const cost = item?.WorkerCost || 0;
                                                                        const [h, m] = (item?.TotalHours || "0:00").split(":").map(Number);
                                                                        const decimalHours = h + (m / 60); // ✅ convert HH:mm to decimal hours
                                                                        const totalCost = cost * decimalHours;

                                                                        return new Intl.NumberFormat("en-IN", {
                                                                            currency: "INR",
                                                                            minimumFractionDigits: 2,
                                                                        }).format(totalCost.toFixed(2));
                                                                    })()}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    <tr>
                                                        <td style={{ textAlign: "end", fontWeight: "600" }} colSpan={2}>Total</td>
                                                        <td style={{ textAlign: "end", fontWeight: "600" }}>{handworkData?.TotalHours}</td>
                                                        <td colSpan={1} style={{ textAlign: "end", fontWeight: "600" }}></td>
                                                        <td colSpan={1} style={{ textAlign: "end", fontWeight: "600" }}> <i className="mdi 
                                                    mdi-currency-inr"></i>
                                                            {new Intl.NumberFormat('en-IN', {
                                                                currency: 'INR',
                                                                minimumFractionDigits: 2,
                                                            }).format(Math.round(handworkData?.WorkerCost) || 0)}</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                        <Row>
                                            <Col style={{ textAlign: "start", fontSize: "14px", fontWeight: "500" }} md={5}>
                                                <Label style={{ fontWeight: "600", fontSize: "15px" }}>Other Costs</Label>
                                                {otherCosts.map((item, index) => {
                                                    return (
                                                        <>
                                                            <div style={{ marginBottom: "3px" }}>{item.OtherCostName}:  <span style={{ color: "blue" }}>
                                                                <i className="mdi 
                                                    mdi-currency-inr"></i>
                                                                {new Intl.NumberFormat('en-IN', {
                                                                    currency: 'INR',
                                                                    minimumFractionDigits: 2,
                                                                }).format(item?.Cost || 0)}</span></div>
                                                        </>
                                                    )
                                                })}
                                            </Col>
                                            <Col style={{ textAlign: "end", fontSize: "14px", fontWeight: "500" }} md={7}>
                                                <div style={{ marginBottom: "3px" }}>Worker Cost:  <span style={{ color: "blue" }}>
                                                    <i className="mdi 
                                                    mdi-currency-inr"></i>
                                                    {new Intl.NumberFormat('en-IN', {
                                                        currency: 'INR',
                                                        minimumFractionDigits: 2,
                                                    }).format(Math.round(handworkData?.WorkerCost) || 0)}</span></div>
                                                <div style={{ marginBottom: "3px" }}>Material Cost:
                                                    <span style={{ color: "blue" }}>
                                                        <i className="mdi 
                                                    mdi-currency-inr"></i>
                                                        {new Intl.NumberFormat('en-IN', {
                                                            currency: 'INR',
                                                            minimumFractionDigits: 2,
                                                        }).format(handworkData?.MaterialCost || 0)}</span>
                                                </div>
                                                <div style={{ marginBottom: "3px" }}>Other Cost:  <span style={{ color: "blue" }}>
                                                    <i className="mdi 
                                                    mdi-currency-inr"></i>
                                                    {new Intl.NumberFormat('en-IN', {
                                                        currency: 'INR',
                                                        minimumFractionDigits: 2,
                                                    }).format(handworkData?.OtherCost || 0)}</span>
                                                </div>
                                                <div style={{ marginBottom: "3px" }}>Total Cost:  <span style={{ color: "green" }}>
                                                    <i className="mdi 
                                                    mdi-currency-inr"></i>
                                                    {new Intl.NumberFormat('en-IN', {
                                                        currency: 'INR',
                                                        minimumFractionDigits: 2,
                                                    }).format(Math.round(handworkData?.MaterialCost + handworkData?.WorkerCost + handworkData?.OtherCost) || 0)}</span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </React.Fragment >
                </ModalBody>
            </div>
        </Modal >
    )
}

export default HandWorkDetailModel